import useGuard from '../hooks/use-guard';

export default function Guard({ permissions, render }) {
  const isAllowed = useGuard(permissions);

  if (isAllowed) {
    return render();
  }

  return null;
}
